import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";
import { EntityService } from "./entity-service";

export class AssetSharedDataService {

    static $inject = ["$q", "entityService"];

    asset: Models.IEntityCharDataPair;
    assetPromise: ng.IPromise<Models.IEntityCharDataPair>;

    assetStatus: Models.IEntityStatus;
    assetStatusPromise: ng.IPromise<Models.IEntityStatus>;

    constructor(private $q: ng.IQService, private entityService: EntityService) {
        this.asset = null;
        this.assetStatus = null;
    }

    RefreshFiles(assetID: string): ng.IPromise<any> {
        if (this.assetPromise == null) {
            this.assetPromise = this.entityService.getEntity(assetID);
            this.assetPromise
                .then((result) => {
                    this.asset = result;
                })
                .finally(() => {
                    this.assetPromise = null;
                });
        }
        return this.assetPromise || this.$q.when(this.asset);
    }

    RefreshAsset(assetID: string): ng.IPromise<any> {
        if (this.assetPromise == null) {
            this.assetPromise = this.entityService.getEntity(assetID);
            this.assetPromise
                .then((result) => {
                    this.asset = result;
                })
                .finally(() => {
                    this.assetPromise = null;
                });
        }
        return this.assetPromise || this.$q.when(this.asset);
    }

    RefreshAssetStatus(assetID: string): ng.IPromise<any> {
        if (this.assetStatusPromise == null) {
            this.assetStatusPromise = this.entityService.getEntityStatus(assetID);
            this.assetStatusPromise
                .then((result) => {
                    this.assetStatus = result;
                })
                .finally(() => {
                    this.assetStatusPromise = null;
                });
        }
        return this.assetStatusPromise || this.$q.when(this.assetStatus);
    }
}